export const compressPdf = async (file) => {
    // Hardcoded keys for now as per instructions
    const PUBLIC_KEY = 'project_public_d90c70f2641a6bb43994d42f8c0fe061_tW2X7983346d6e9b7d4c0f301c8e863ee93ed';

    console.log('START: compressPdf');
    console.log('File:', file.name, 'Size:', file.size);

    try {
        // 1. Authentication
        console.log('Authenticating...');
        const authResponse = await fetch('https://api.ilovepdf.com/v1/auth', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ public_key: PUBLIC_KEY })
        });

        if (!authResponse.ok) {
            console.error('Auth failed:', await authResponse.text());
            throw new Error('Authentication failed');
        }
        const { token } = await authResponse.json();
        console.log('Auth success. Token:', token ? 'Received' : 'Missing');

        // 2. Start Task
        console.log('Starting task...');
        const startResponse = await fetch('https://api.ilovepdf.com/v1/start/compress', {
            method: 'GET',
            headers: { 'Authorization': `Bearer ${token}` }
        });

        if (!startResponse.ok) throw new Error('Failed to start task');
        const { server, task } = await startResponse.json();
        console.log('Task started:', task, 'Server:', server);

        // 3. Upload File
        const formData = new FormData();
        formData.append('task', task);
        formData.append('file', file);

        console.log('Uploading file...');
        const uploadResponse = await fetch(`https://${server}/v1/upload`, {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` },
            body: formData
        });

        if (!uploadResponse.ok) throw new Error('Upload failed');
        const { server_filename } = await uploadResponse.json();
        console.log('Upload success. Server Filename:', server_filename);

        // 4. Process File
        console.log('Processing (compressing)...');
        const processResponse = await fetch(`https://${server}/v1/process`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                task: task,
                tool: 'compress',
                files: [{ server_filename, filename: file.name }],
                compression_level: 'extreme'
            })
        });

        if (!processResponse.ok) throw new Error('Processing failed');
        console.log('Processing started/complete.');

        // 5. Download File
        console.log('Downloading result...');
        const downloadResponse = await fetch(`https://${server}/v1/download/${task}`, {
            method: 'GET',
            headers: { 'Authorization': `Bearer ${token}` }
        });

        if (!downloadResponse.ok) throw new Error('Download failed');

        const blob = await downloadResponse.blob();
        console.log('Download complete. Blob size:', blob.size);

        const newFile = new File([blob], file.name, { type: 'application/pdf' });
        return newFile;

    } catch (error) {
        console.error('PDF Compression Error:', error);
        throw error;
    }
};
